import React, { useEffect, useState } from "react";
import apiService from "../../service/apiservice/apiService";
import { List, Typography } from "antd";
import { useReadMemory } from "../generic/hooks/useReadMemory";
import MemoryType from "../../service/memory/enum/MemoryType";
import { useWriteMemory } from "../generic/hooks/useWriteMemory";
import { useSetRecoilState } from "recoil";
import { userDetails } from "../../components/recoil/userDataRecoil";
import CheckIcon from "@mui/icons-material/Check";
import {
  isOrganizationChanged,
  teamList,
} from "../../components/recoil/teamsRecoil";
import "./HomeScreenSidebar.css";
import SearchInput from "../generic/elements/search/SearchInput";
import { useNavigate } from "react-router";
import { RoleToLinkMapper } from "../utils/UrlUtils";

const OrganizationList = () => {
  const userData = useReadMemory(MemoryType.USER);
  const navigate = useNavigate();
  const setMemory = useWriteMemory();
  const setTeams = useSetRecoilState(teamList);
  const setIsOrganizationChanged = useSetRecoilState(isOrganizationChanged);
  const setUserInformation = useSetRecoilState(userDetails);
  const [organizationList, setOrganizationListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleOrganizationClick = (id) => {
    if (userData?.organizationIdentifier !== id.toString()) {
      setMemory(MemoryType.USER, {
        ...userData,
        organizationIdentifier: id.toString(),
      });
      setUserInformation({
        ...userData,
        organizationIdentifier: id.toString(),
      });
      setTeams([]);
      setIsOrganizationChanged((prev) => !prev);
      navigate(RoleToLinkMapper(userData?.jobTitle) + "homepage");
      window.location.reload();
    }
  };

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      const endpoint = "niramayafoundation/api/v1/organization";
      const params = {
        searchQuery,
      };

      const response = await apiService.get(endpoint, params);
      const sortedData = Array.isArray(response)
        ? response?.sort((a, b) => {
            if (a.id.toString() === userData?.organizationIdentifier) return -1;
            if (b.id.toString() === userData?.organizationIdentifier) return 1;
            return 0;
          })
        : [];
      setOrganizationListData(sortedData);
      setLoading(false);
    };

    fetchOrganizations();
  }, [searchQuery, userData?.organizationIdentifier]);

  return (
    <>
      <SearchInput
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        cssClass="searchFilterContainer organizationSearch"
        searchPlaceholder="Search Organization"
      />
      <List
        itemLayout="horizontal"
        dataSource={organizationList}
        loading={loading}
        renderItem={(item) => {
          const isSelected =
            userData?.organizationIdentifier === item?.id.toString();
          return (
            <List.Item
              onClick={() => handleOrganizationClick(item?.id)}
              className={`custom-list-item ${isSelected ? "selected" : ""}`}
              actions={[
                isSelected && (
                  <CheckIcon style={{ fill: "var(--secondary-theme-color)" }} />
                ),
              ]}
            >
              <List.Item.Meta
                title={
                  <Typography.Title level={5}>{item?.name}</Typography.Title>
                }
                description={item?.address}
              />
            </List.Item>
          );
        }}
      />
    </>
  );
};

export default OrganizationList;
